export default __webpack_public_path__ + "static/testimonial-britt-95c6241f655d8acae611a692546f4923.jpg";